// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { PRESUPUESTADOR_ON_CHANGE_SUMAR_CANTIDAD } from './constants'

export function onChangeSumarCantidad(sumarCantidad) {
  return {
    type: PRESUPUESTADOR_ON_CHANGE_SUMAR_CANTIDAD,
    data: {
      sumarCantidad,
      changeAmount: true
    },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_ON_CHANGE_SUMAR_CANTIDAD:
      return {
        ...state,
        ...action.data,
      }

    default:
      return state
  }
}
